import React, {
	useEffect,
	useState,
	forwardRef,
	useImperativeHandle,
} from "react";
import moment from "moment";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { inputValidationChecks } from "../../../utils/formValidation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Datepicker = forwardRef((props, ref) => {
	const {
		val,
		setVal,
		label = "",
		classInput = "",
		classLabel = "",
		validation = "",
		minDate = "",
		maxDate = "",
		name = "",
	} = props;

	useImperativeHandle(ref, () => {
		return {
			validateInput: validateInput,
		};
	});

	const dispatch = useDispatch();
	const renewalData = useSelector((state) => state.RenewalData);
	const renewalId = useSelector((state) => state.RenewalId);

	const [submitted, setSubmitted] = useState(false);
	const [error, setError] = useState("");
	const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
		<button
			value={value}
			onChange={(e) => handleUserInput(e.target.value)}
			className={classInput + `${error === "" ? "" : " is-invalid"}`}
			placeholder={label}
			onClick={onClick}
			ref={ref}
		>
			{value}
		</button>
	));

	const handleUserInput = (date) => {
		if (name === "startPolicy") {
			let start = new Date(moment(date).format("YYYY-MM-DD"));
			start.setDate(start.getDate() + 1);
			setVal(start.getTimezoneOffset());

			changeStartDate(date);
			if (submitted) {
				validateInput(date);
			}
		} else {
			let end = new Date(moment(date).format("YYYY-MM-DD"));
			setVal(end);

			changeEndDate(date);
			if (submitted) {
				validateInput(date);
			}
		}
	};

	const changeEndDate = (value) => {
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				...renewalData,
				policy_end: moment(value).format("YYYY-MM-DD"),
			}),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
			});
	};

	const validateInput = (value = null) => {
		let errors = false;
		if (value) {
			errors = inputValidationChecks(value, validation, setError);
		} else {
			errors = inputValidationChecks(val, validation, setError);
			setSubmitted(true);
		}

		return errors;
	};

	const changeStartDate = (value) => {
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				...renewalData,
				policy_start: moment(value).format("YYYY-MM-DD"),
			}),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
			});
	};

	return (
		<>
			<label
				htmlFor="formGroupExampleInput"
				className={classLabel}
				style={{ display: "block" }}
			>
				{label}
			</label>
			<DatePicker
				selected={val}
				onChange={(date) => handleUserInput(date)}
				customInput={<ExampleCustomInput />}
				dropdownMode="select"
				minDate={minDate}
				maxDate={maxDate}
				name={name}
			/>
			{error && <div className="invalid-date">{error}</div>}
		</>
	);
});

export default Datepicker;
